import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getCustomerQueryOptions } from './get-customer'

const customerAddressDeleteMutationDocument = graphql(`
  mutation customerAddressDelete($input: CustomerAddressDeleteInput!) {
    customerAddressDelete(input: $input) {
      errors {
        __typename
        ... on AddressNotFoundError {
          message
        }
      }
      customer {
        id
      }
    }
  }
`)

export const customerAddressDelete = ({ addressId }: { addressId: string }) => {
  return execute(customerAddressDeleteMutationDocument, {
    input: {
      id: addressId,
    },
  })
}

type UsecustomerAddressDeleteOptions = {
  mutationConfig?: MutationConfig<typeof customerAddressDelete>
}

export const usecustomerAddressDelete = ({
  mutationConfig,
}: UsecustomerAddressDeleteOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    mutationFn: async (params: { addressId: string }) => {
      const response = await customerAddressDelete(params)
      return response
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryOptions().queryKey,
      })
      onSuccess?.(...args)
    },
    ...restConfig,
  })
}
